// @ts-strict-ignore
import React, { useRef, useState } from 'react';
import { Pressable } from 'react-native';
import { TouchableProps } from '../../ui';

const THRESHOLD_COUNT = 5;
const THRESHOLD_TIMESPAN = 1000; // milliseconds

export const SecretTouchable: React.
  FCWithChildren<TouchableProps & { onSecretClick: () => void }> = ({
  onClick,
  onSecretClick,
  ...touchableProps
}) => {
  const [clickCount, setClickCount] = useState<number>(0);
  const currentTimeout = useRef<NodeJS.Timeout>();

  const handleClick: typeof onClick = (e?: any) => {
    setClickCount(clickCount + 1);

    if (clickCount >= THRESHOLD_COUNT) {
      onSecretClick();
      setClickCount(0);
    }

    if (!currentTimeout.current) {
      currentTimeout.current = setTimeout(() => {
        setClickCount(0);
        onClick(e);
        currentTimeout.current = undefined;
      }, THRESHOLD_TIMESPAN);
    }

    e.stopPropagation();
  };

  return (
    <Pressable onPress={handleClick} {...touchableProps} />
  );
};
